<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{ modelValue?: number; placeholder: string }>();
const emits = defineEmits<{ (e: 'update:modelValue', value: number) }>();

const inputRef = ref<HTMLInputElement | null>(null);
const isFocused = ref(false);

/**
 * フォーカス状態を設定する
 * @param focused - フォーカス状態
 */
const setFocused = (focused: boolean): void => {
  isFocused.value = focused;
  if (!inputRef.value) return;
  inputRef.value.type = focused ? 'number' : 'text';
  if (!focused) {
    emits('update:modelValue', parseNumber(inputRef.value.value));
  }
};

/**
 * パースした数値を返す
 * バリデーションも行っており、値のMax/Minをチェックし、小数点以下6桁に制限する
 * @param value - Parseする値
 */
function parseNumber(value: string): number {
  let num = parseFloat(value.replace(/[^\d.-]/g, ''));
  if (isNaN(num)) return 0;
  if (num > Number.MAX_SAFE_INTEGER) num = Number.MAX_SAFE_INTEGER;
  if (num < Number.MIN_SAFE_INTEGER) num = Number.MIN_SAFE_INTEGER;
  return parseFloat(num.toFixed(6)); // 小数点以下6桁に制限
}
</script>
<template>
  <input
    ref="inputRef"
    :value="modelValue"
    :step="0.1"
    :max="Number.MAX_SAFE_INTEGER"
    :min="Number.MIN_SAFE_INTEGER"
    :placeholder="props.placeholder"
    class="decimal-number-input"
    @focus="() => setFocused(true)"
    @blur="setFocused(false)"
  />
</template>
<style lang="scss" scoped>
.decimal-number-input {
  width: 100%;
  padding: 7px 8px;
  border-radius: 4px;
  border: 1px solid $borderDefault;
  font-family: Noto Sans JP;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}
</style>
